module.exports = __webpack_public_path__ + "media/images/error-date-f099672e.png";